import { Component, OnInit } from '@angular/core';
import { angularMath } from 'angular-ts-math';
import { AppService } from 'src/app/modules/shared/services/geral/app.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-documentos',
  templateUrl: './upload-documentos.component.html',
  styleUrls: ['./upload-documentos.component.css']
})
export class UploadDocumentosComponent implements OnInit {

  constructor(public svc: AppService, private router: Router, private tl: TranslateService) { }

  public clientes_lista: any = [];
  public processos_lista: any = [];
  public docAnexo: File[] = [];
  public dropVazio: boolean = false;
  public flagLimite: boolean = true;
  public novo_contrato: any = {
    id_cliente: "",
    id_processo: "",
    valor_contrato: "",
    num_contrato: "",
    nome_arquivo: "",
    tipo_conteudo: "",
    mime: "",
    binario_arquivo: ""
  };
  public spinDoc = false;

  public buscarProcesso(id_processo) {
    try {
      var retorno = null;
      this.processos_lista.forEach(item => {
        if (item.id_processo == id_processo) {
          retorno = item;
          return false;
        }
      });
      return retorno;
    } catch (e) {
      throw e;
    }
  }

  onSelect(event) {
    try {
      this.docAnexo = [];
      this.docAnexo.push(...event.addedFiles);
      let that = this;

      if (this.docAnexo[0].type.indexOf('pdf') == -1) {
        this.docAnexo = [];
        this.svc.sbExibirAlerta("warning", this.tl.instant("geral.mensagens.atencao"), "Formato de Arquivo Inválido!<br />Envie um Arquivo <b>.pdf</b>");
      }

      if (this.docAnexo[0]) {
        var reader = new FileReader();
        reader.onload = function (e: any) {
          if (e.target.result.indexOf("base64,") != -1) {
            that.novo_contrato.binario_arquivo = e.target.result.split("base64,")[1];
          } else {
            that.novo_contrato.binario_arquivo = e.target.result;
          }
          that.novo_contrato.nome_arquivo = that.docAnexo[0].name;
          that.novo_contrato.mime = that.docAnexo[0].type;
          that.novo_contrato.tipo_conteudo = that.docAnexo[0].type;
        };
        reader.readAsDataURL(this.docAnexo[0]);
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  onRemove(event) {
    try {
      this.docAnexo.splice(this.docAnexo.indexOf(event), 1);
      this.novo_contrato.binario_arquivo = null;
      this.novo_contrato.nome_arquivo = "";
      this.novo_contrato.mime = "";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public onClienteChange(event, f: NgForm) {
    try {
      if (this.novo_contrato.id_cliente != "") {
        this.novo_contrato.id_processo = "";
        this.carregarProcessos(this.novo_contrato.id_cliente);
      } else {
        this.limparCampos(f);
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public onProcessoChange(value) {
    try {
      var processo = this.buscarProcesso(value);
      if (processo != null) {
        if (processo.limite == "Não") {
          this.flagLimite = false;
        } else {
          this.flagLimite = true;
        }
      } else {
        this.flagLimite = true;
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public bytesToSize(bytes): string {
    if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
    else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
    else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + " KB"; }
    else if (bytes > 1) { bytes = bytes + " bytes"; }
    else if (bytes == 1) { bytes = bytes + " byte"; }
    else { bytes = "0 bytes"; }
    return bytes;
  }

  public carregarClientes() {
    this.svc.CadastroPoderesPesquisar();
    this.svc.CadastroPoderes().subscribe((resp) => {
      if (resp != null)
        this.clientes_lista = resp.clientes;
    });
  }

  public carregarProcessos(id_cliente) {
    try {
      this.svc.TipoProcessoConfiguradoPesquisar(id_cliente);
      this.svc.TipoProcessoConfigurado().subscribe((resp) => {
        if (resp != null)
          this.processos_lista = resp.Processos;
      });
    } catch (e) {
      throw e;
    }
  }

  public limparCampos(f: NgForm) {
    try {
      f.reset();
      var that = this;
      setTimeout(() => {
        that.docAnexo = [];
        that.dropVazio = false;
        that.novo_contrato = {
          id_cliente: "",
          id_processo: "",
          valor_contrato: "",
          num_contrato: "",
          nome_arquivo: "",
          tipo_conteudo: "",
          mime: "",
          binario_arquivo: ""
        };
      });
    } catch (e) {
      throw e;
    }
  }

  public processar(f: NgForm) {
    try {
      if (f.valid) {
        if (this.docAnexo.length > 0) {
          if (this.novo_contrato.valor_contrato == "") this.novo_contrato.valor_contrato = "0";
          var processo: any = this.buscarProcesso(this.novo_contrato.id_processo);
          //Valor Autorizador Externo
          var valor_min_cli: number = parseInt(this.svc.fnRemoverMascara(processo.valor_minimo_autorizador_cliente)) / 100;
          var valor_max_cli: number = parseInt(this.svc.fnRemoverMascara(processo.valor_maximo_autorizador_cliente)) / 100;
          //Valor Autorizador Interno
          var valor_min_int: number = parseInt(this.svc.fnRemoverMascara(processo.valor_minimo_autorizador_interno)) / 100;
          var valor_max_int: number = parseInt(this.svc.fnRemoverMascara(processo.valor_maximo_autorizador_interno)) / 100;
          //Valor Mínimo Assinatura
          var valor_minimo: number = parseInt(this.svc.fnRemoverMascara(processo.valor_minimo_assinatura)) / 100;
          //Valor Informado
          var valor_calculo: number = parseInt(this.svc.fnRemoverMascara(this.novo_contrato.valor_contrato)) / 100;

          var valor_valido: boolean = true;
          if (valor_calculo < valor_minimo) {
            valor_valido = false;
            this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("upload_documentos.mensagens.valor_minimo") + processo.valor_minimo_assinatura);
          }
          if (valor_calculo < valor_min_cli || valor_calculo > valor_max_cli) {
            if (valor_valido) this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("upload_documentos.mensagens.valor_imprevisto"));
            valor_valido = false;
          }
          if (valor_calculo < valor_min_int || valor_calculo > valor_max_int) {
            if (valor_valido) this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("upload_documentos.mensagens.valor_imprevisto"));
            valor_valido = false;
          }

          if (valor_valido) {
            let valor = this.novo_contrato.valor_contrato;
            this.novo_contrato.valor_contrato = parseInt(this.svc.fnRemoverMascara(valor.toString())); 
            this.spinDoc = true;
            this.svc.IncluirContrato(this.novo_contrato);
            this.svc.ContratosIncluido().subscribe((resp) => {
              if (resp == false) this.spinDoc = false;
              else if (resp != null) {
                this.spinDoc = false;
                this.limparCampos(f);
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("upload_documentos.mensagens.upload_realizado"));
              }
            });
          }
        } else {
          this.dropVazio = true;
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("upload_documentos.mensagens.subir_arquivo"));
        }
      } else {
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.dropVazio = false;
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_obrigatorios"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  ngOnInit() {
    this.carregarClientes();
  }

}
